import { render, staticRenderFns } from "./modifyitem.vue?vue&type=template&id=39b3f53c&scoped=true&"
import script from "./modifyitem.vue?vue&type=script&lang=js&"
export * from "./modifyitem.vue?vue&type=script&lang=js&"
import style0 from "./modifyitem.vue?vue&type=style&index=0&id=39b3f53c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b3f53c",
  null
  
)

component.options.__file = "modifyitem.vue"
export default component.exports